var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { SwatchPickerDesign, } from '../SwatchPicker/SwatchPickerDesign';
const swatchSize = 24;
const AttributeFilter = (_a) => {
    var { disabled, id, isOn, label, onClick } = _a, restProps = __rest(_a, ["disabled", "id", "isOn", "label", "onClick"]);
    const buttonStyles = useMemo(() => (css `
        ${styleUtils.buttonReset}
        ${theme.typeStyles.bodySmallStyles}
        align-items: center;
        background-color: ${theme.colors.gray100};
        border-color: ${theme.colors.gray400};
        border-radius: ${theme.spacing.base};
        border-style: solid;
        border-width: ${styleUtils.rem(1)};
        cursor: pointer;
        display: flex;
        padding-bottom: ${theme.spacing.x2};
        padding-left: ${theme.spacing.x3};
        padding-right: ${theme.spacing.x3};
        padding-top: ${theme.spacing.x2};
        white-space: nowrap;

        ${isOn && css `
          ${theme.typeStyles.bodyBoldStyles}
          background-color: ${theme.colors.accent300};
          border-color: ${theme.colors.accent300};
        `}

        ${disabled && css `
          background-color: ${isOn ? theme.colors.surfaceGrayDisabled : theme.colors.gray100};
          border-color: ${theme.colors.surfaceGrayDisabled};
          color: ${theme.colors.textDisabled};
          cursor: default;
        `}
      `), [
        disabled,
        isOn,
    ]);
    const swatchContainerStyles = useMemo(() => (css `
        height: ${styleUtils.rem(swatchSize)};
        width: ${styleUtils.rem(swatchSize)};
        margin-right: ${theme.spacing.x2};

        ${disabled && css `
          opacity: 0.3;
        `}
      `), [
        disabled,
    ]);
    return (_jsxs("button", Object.assign({ "aria-checked": isOn, css: buttonStyles, disabled: disabled, id: id, onClick: onClick, role: "checkbox", type: "button" }, { children: [('swatchColor' in restProps
                || 'swatchImageUrl' in restProps)
                && (_jsx("span", Object.assign({ css: swatchContainerStyles }, { children: _jsx(SwatchPickerDesign, { color: 'swatchColor' in restProps ? restProps.swatchColor : undefined, imageUrl: 'swatchImageUrl' in restProps ? restProps.swatchImageUrl : undefined }) }))), _jsx("span", { children: label })] })));
};
const MemoizedAttributeFilter = memo(AttributeFilter);
export { MemoizedAttributeFilter as AttributeFilter };
// MC-1068 Temporary hack for Storybook.
export default AttributeFilter;
